<script>
export default {
  methods: {
    alertPrepare() {
      return this.$alert(this.$t('service_prepare'))
    },
  },
}
</script>

<template>
  <div class="quick-service">
    <div class="container">
      <div class="main-title">
        <h2>{{ $t('quick_service') }}</h2>
        <p>{{ $t('pay_home.home_sec_quick_desc') }}</p>
      </div>
      <div class="main-content">
        <router-link
          :to="{
            name: 'direct-exchange',
          }"
          class="item"
        >
          <div class="item-content">
            <span>
              {{ $t('pay_home.home_sec_quick_cont_1') }}
            </span>
            <div class="img-wrap">
              <img src="@assets/images/v2/img-quick-01.png" alt="" />
            </div>
          </div>
          <div class="pc">
            <div class="btn btn-primary">
              {{ $t('pay_home.home_sec_quick_btn') }}
            </div>
          </div>
        </router-link>

        <a class="item" @click="alertPrepare">
          <div class="item-content">
            <span>
              {{ $t('pay_home.home_sec_quick_cont_2') }}
            </span>
            <div class="img-wrap">
              <img src="@assets/images/v2/img-quick-02.png" alt="" />
            </div>
          </div>
          <div class="pc">
            <div class="btn btn-primary">
              {{ $t('pay_home.home_sec_quick_btn') }}
            </div>
          </div>
        </a>

        <router-link :to="{ name: 'money' }" class="item">
          <div class="item-content">
            <span>
              {{ $t('pay_home.home_sec_quick_cont_3') }}
            </span>
            <div class="img-wrap">
              <img src="@assets/images/v2/img-quick-03.png" alt="" />
            </div>
          </div>
          <div class="pc">
            <div class="btn btn-primary">
              {{ $t('pay_home.home_sec_quick_btn') }}
            </div>
          </div>
        </router-link>

        <router-link :to="{ name: 'account-transfer' }" class="item">
          <div class="item-content">
            <span>
              {{ $t('pay_home.home_sec_quick_cont_4') }}
            </span>
            <div class="img-wrap">
              <img src="@assets/images/v2/img-quick-04.png" alt="" />
            </div>
          </div>
          <div class="pc">
            <div class="btn btn-primary">
              {{ $t('pay_home.home_sec_quick_btn') }}
            </div>
          </div>
        </router-link>

        <router-link :to="{ name: 'create-address' }" class="item">
          <div class="item-content">
            <span>
              {{ $t('pay_home.home_sec_quick_cont_5') }}
            </span>
            <div class="img-wrap">
              <img src="@assets/images/v2/img-quick-05.png" alt="" />
            </div>
          </div>
          <div class="pc">
            <div class="btn btn-primary">
              {{ $t('pay_home.home_sec_quick_btn') }}
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';
</style>

<style scoped>
.quick-service {
  background-color: #fafdff;
}
.quick-service .container {
  padding: 120px 0;
}
.quick-service .main-content {
  display: flex;
  justify-content: space-around;
}
.quick-service .item {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 18%;
  padding: 20px;
  margin-right: 2.5%;
  cursor: pointer;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 1px 1px 12px 0 #8cc2d71a;
  gap: 20px;
}
.quick-service .item .item-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.quick-service .item .btn {
  width: fit-content;
  height: 34px;
  border-radius: 50px;
}

.quick-service .item:last-child {
  margin: 0;
}

/* .quick-service .item:hover {
  font-weight: bold;
  box-shadow: 10px 10px 10px #eee;
  transition: 0.3s;
} */

.quick-service span {
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
}

@media (max-width: 768px) {
  .quick-service {
    padding: 60px 0;
  }
  .quick-service .main-content {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .quick-service .item {
    width: calc(50% - 5px);
    padding: 15px;
    margin-right: 0;
    margin-bottom: 10px;
  }
  .quick-service span {
    font-size: 14px;
    line-height: 18px;
  }
  .quick-service .item:nth-child(1) .img-wrap img {
    width: 30px;
  }
  .quick-service .item:nth-child(2) .img-wrap img {
    width: 21px;
  }
  .quick-service .item:nth-child(3) .img-wrap img {
    width: 44px;
  }
  .quick-service .item:nth-child(4) .img-wrap img {
    width: 29px;
  }
  .quick-service .item:nth-child(5) .img-wrap img {
    width: 38px;
  }
  .quick-service .item .item-content {
    gap: 0;
  }
}
</style>
